import(/* webpackMode: "eager" */ "D:\\b\\baczonedz\\src\\app\\tools\\planner\\page.tsx");
